import React from 'react';

import Header from './partials/header/Header';
import Menu from './partials/menu/Menu';
import NavFloor from './partials/nav-floor/NavFloor';

import * as css from './css/footer';

function Footer(props) {

  const { className } = props;
  return (
      <css.Footer className={className} id='footer'>
        <css.Container>
          <css.Content>
            {/* header */}
            <css.Header as={Header} />

            {/* split line 1 */}
            <css.SplitLine />
            {/* menu */}
            <css.Menu as={Menu} />
            {/* split line 2 */}
            <css.SplitLine />
            {/* nav floor */}
            <css.NavFloor as={NavFloor} />
          </css.Content>
          {/* bg img */}
          <img src={require('./img/bg.png')} alt='' className='bg' />
          <img
              src={require('./img/left-top.png')}
              alt=''
              className='left-top-bg'
          />
          <img
              src={require('./img/right-top.png')}
              alt=''
              className='right-top-bg'
          />
          <img
              src={require('./img/left-top-decoration.png')}
              alt=''
              className='left-top-decoration'
          />
          <img
              src={require('./img/right-top-decoration.png')}
              alt=''
              className='right-top-decoration'
          />
          <img
              src={require('./img/left-bottom-decoration.png')}
              alt=''
              className='left-bottom-decoration'
          />
          <img
              src={require('./img/right-bottom-decoration.png')}
              alt=''
              className='right-bottom-decoration'
          />
        </css.Container>
      </css.Footer>
  );
}

export default Footer;
